// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"eR-z","inlineTitle":"fR-z","sponsoredAdsWrapper":"gR-z","marketplaceRecosWrapper":"hR-z"};